import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { theme as themeDefault } from '../../styles/theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      textTransform: 'none',
      minWidth: 56,
      padding: '15px 0',
      color: themeDefault.color.text.B5,
      opacity: 1,
      '&:hover': {
        color: themeDefault.color.text.B4,
        opacity: 1
      },
      '&$selected': {
        color: themeDefault.color.primary.default
      }
    },
    selected: {},
    wrapper: {
      height: 32,
      ...theme.typography.body1,
      fontWeight: themeDefault.typography.fontWeight.medium
    }
  })
);

export default useStyles;
